module.exports = __webpack_public_path__ + "media/Click Response Button.b5e84aff.mp3";